import { trackEvent } from '@fiverr-private/gtm';
import { DEPARTMENT_KEYS } from '../../shared/comeet/comeet_api/constants';

export const GTM_CUSTOM_EVENT_CAREERS_PAGE = 'careers-page-view';
export const GTM_CUSTOM_EVENT_JOB_PAGE = 'careers-job-view';
export const GTM_CUSTOM_EVENT_THANKYOU_PAGE = 'careers-thankyou-view';

export const GTM_CUSTOM_EVENTS_TEAMS = {
    [DEPARTMENT_KEYS.Technology]: 'careers-team-view-rnd',
    [DEPARTMENT_KEYS.Product]: 'careers-team-view-product',
    [DEPARTMENT_KEYS.BI]: 'careers-team-view-bi',
    [DEPARTMENT_KEYS.Design]: 'careers-team-view-design',
    [DEPARTMENT_KEYS.Marketing]: 'careers-team-view-corporate_marketing',
    [DEPARTMENT_KEYS['Marketplace Business Operations']]: 'careers-team-view-marketplace_business_ops',
    [DEPARTMENT_KEYS['Customer Journey']]: 'careers-team-view-customer_support',
    [DEPARTMENT_KEYS['G&A']]: 'careers-team-view-gna',
    [DEPARTMENT_KEYS.Finance]: 'careers-team-view-finance',
    [DEPARTMENT_KEYS.Sales]: 'careers-team-view-sales',
    [DEPARTMENT_KEYS.IT]: 'careers-team-view-it',
};

export const trackPageEvent = (event) => trackEvent(event);
